module.exports = __webpack_public_path__ + "static/img/loading.9f5063d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loading.gif
// module id = 293
// module chunks = 0 1 2 3 4 5 6 7 8 9